import { useQuery } from '@tanstack/react-query';

import { resolvePermissions } from '../../domain';
import { fetchPermissions } from '../service';

export const PERMISSIONS_QUERY_KEY = ['permissions'] as const;

export const usePermissions = (options?: { enabled?: boolean }) => {
	return useQuery({
		queryKey: PERMISSIONS_QUERY_KEY,
		queryFn: fetchPermissions,
		select: resolvePermissions,
		staleTime: Infinity,
		gcTime: Infinity,
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		enabled: options?.enabled ?? true,
	});
};
